import AppointmentListSection from '../../components/AppointmentsComps/ListComps/AppointmentListSection';
import FilterAppointmentSection from '../../components/AppointmentsComps/ListComps/FilterAppointmentSection';
import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import AppointmentListProvider from '../../contexts/AppointmentListProvider';

const List = () => {
  // rendering appointment history page component here
  return (
    <>
      <PageTitle title={'Appointment History'} />

      <AppointmentListProvider>
        <FilterAppointmentSection />
        <AppointmentListSection />
      </AppointmentListProvider>
    </>
  );
};

export default List;
